import createVueApp from '@phoenix/createVueApp';
import StrapFinderConfigurator from '@maison/components/strapFinder/StrapFinderConfigurator.vue';

document.querySelectorAll('.phoenix-strap-finder-configurator').forEach((el) => {
  const app = createVueApp();
  app.component('StrapFinderConfigurator', StrapFinderConfigurator);
  app.mount(el);
});
